import React from 'react';
import { StytchLogin } from '@stytch/react';
import { Products, OAuthProviders } from '@stytch/vanilla-js';
import { Heading } from '../../components/Typography/Typography';
import styles from './LoginPage.module.scss';

const LoginPage: React.FC = () => {
  const config = {
    products: [Products.oauth, Products.emailMagicLinks],
    oauthOptions: {
      providers: [
        {
          type: OAuthProviders.Google,
          options: {
            login_redirect_url: `${window.location.origin}/authenticate`,
            signup_redirect_url: `${window.location.origin}/authenticate`,
          },
        },
        // {
        //   type: OAuthProviders.Microsoft,
        //   options: {
        //     login_redirect_url: `${window.location.origin}/authenticate`,
        //     signup_redirect_url: `${window.location.origin}/authenticate`,
        //   },
        // },
      ],
      // These are not needed since we specify them per provider
      // loginRedirectURL: `${window.location.origin}/authenticate`,
      // signupRedirectURL: `${window.location.origin}/authenticate`,
    },
    emailMagicLinksOptions: {
      loginRedirectURL: `${window.location.origin}/authenticate`,
      loginExpirationMinutes: 60,
      signupRedirectURL: `${window.location.origin}/authenticate`,
      signupExpirationMinutes: 60,
    },
  };

  const stytchStyles = {
    container: {
      width: '100%',
      maxWidth: '100%',
      borderColor: 'none',
    },
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <Heading level={2} align="center">
            Welcome to Enlo
          </Heading>
        </div>
        <StytchLogin config={config} styles={stytchStyles} />
      </div>
    </div>
  );
};

export default LoginPage;
